import { useEffect } from 'react';
import { useQuery } from 'react-query';
import { useApi } from 'utils/api';
import type { FlagData } from '../useFeatureFlags';
import { redirectToPortalUnavailable } from './redirect';

export const PORTAL_MAINTENANCE_FLAG = 'cerebral_portal_maintenance_mode';

const POLL_INTERVAL = 60 * 1000;

// Kicks already-open tabs out to the marketing site once the portal cutover flag is turned on.
export const usePortalMaintenanceRedirect = (): void => {
  const api = useApi();

  const { data: isMaintenanceMode } = useQuery({
    queryKey: ['portalMaintenanceMode'],
    queryFn: () => api.get<FlagData>('/api/v1/feature_flags'),
    select: response => !!response?.data?.[PORTAL_MAINTENANCE_FLAG],
    enabled: !!api,
    staleTime: 0,
    refetchInterval: POLL_INTERVAL,
    refetchOnWindowFocus: true
  });

  useEffect(() => {
    if (isMaintenanceMode) {
      redirectToPortalUnavailable();
    }
  }, [isMaintenanceMode]);
};
